module.exports = __webpack_public_path__ + "static/media/play_grey.d7ec81b8.svg";